import { Component } from '@angular/core'
import { map } from 'rxjs/operators'
import { RoutingService } from '@spartacus/core'

@Component({
  selector: 'mb-search-active-filters',
  templateUrl: './mb-search-top-filters.component.html',
})
export class MbSearchTopFiltersComponent {

  query$ = this.routingService.getRouterState().pipe(
    map(state => state.state.params['query'] || state?.state?.queryParams?.['query'])
  )

  constructor (protected routingService: RoutingService) {
  }
}
